export default __webpack_public_path__ + "static/media/local-list-actions.cf163297.png";